import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import { BORDER_RADIUS } from '@src/styles/config';

export const StyledRecording = styled('div')`
  .warning-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    padding: 8px;
    background: ${COLOR.functionalRed[8]};
    border-radius: ${BORDER_RADIUS};
    color: ${COLOR.functionalRed.default};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    word-wrap: break-word;

    .warning-icon {
      width: 16px;
      height: 16px;
      color: ${COLOR.functionalRed.default};
  }
`;

export const StyledCheckAudioQuality = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;

  .success {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .success-title {
      display: flex;
      gap: 4px;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      text-align: center;
      color: ${COLOR.greenV2.default};

      .success-title-icon {
        width: 21px;
        height: 24px;
      }
    }

    .success-check {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      text-align: left;
      color: ${COLOR.black.default};
    }
  }

  .error {
    display: flex;
    flex-direction: column;
    gap: 6px;

    .box-title {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      .evaluate-text {
        font-size: 14px;
        font-family: 'SF Pro Text';
        font-weight: 510;
        line-height: 20px;
        word-wrap: break-word;
        color: ${COLOR.darkGray};
      }
    }

    .box-quality {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 2px;

      .box-quality-item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        border-right: 1px solid ${COLOR.darkV2[16]};
        gap: 2px;
        padding: 0px 12px;

        .quality-text {
          font-size: 12px;
          font-family: 'SF Pro Text';
          font-weight: 400;
          line-height: 16px;
          word-wrap: break-word;
          color: ${COLOR.darkV2[64]};
        }

        .check-icon {
          color: ${COLOR.greenV2.default};
          width: 32px;
          height: 32px;
        }

        .close-icon {
          color: ${COLOR.functionalRed.default};
          width: 32px;
          height: 32px;
        }

        &.last-item {
          border-right: none;
        }
      }
    }
  }
`;

export const StyledRecordingHeader = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: ${COLOR.darkBlue};

  .back-btn {
    padding: 8px;
    width: 32px;
    height: 32px;
    min-width: 10px;

    .icon {
      width: 24px;
      height: 24px;
      color: ${COLOR.darkBlue};
      align-items: center;
      align-self: center;

      &.disabled {
        color: ${COLOR.darkV2[64]};
      }
    }
  }

  .back-btn:focus {
    background: none;
  }

  .sentence {
    display: flex;
    flex-direction: row;
    justify-content: center;

    .current-sentence {
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: -0.4px;
      color: ${COLOR.darkBlue};
    }

    .total-sentences {
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 28px;
      letter-spacing: -0.4px;
      color: ${COLOR.darkV2[64]};
    }
  }

  .grid-button {
    min-width: 10px;
    width: 32px;
    height: 32px;
    padding: 8px;
  }

  .grid-button:focus {
    background: none;
  }

  .grid-button-icon {
    color: ${COLOR.darkBlue};

    &.disabled {
      color: ${COLOR.darkV2[64]};
    }
  }
`;

export const StyledRecordingContent = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0px;
  padding: 24px;
  background: ${COLOR.white};
  border-radius: ${BORDER_RADIUS};
  gap: 16px;

  .sentence {
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    word-wrap: break-word;
    color: ${COLOR.darkGray};

    .box-word {
      font-weight: 700;
      color: ${COLOR.blueV2};
      border-radius: 6px;
    }
  }

  .divider {
    border: 1px solid ${COLOR.secondary[80]};
  }

  .nsws {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-self: start;
    flex-wrap: wrap;
    gap: 8px;
    padding: 0px;

    .nsws-word {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      gap: 4px;
      padding: 4px 8px;
      color: ${COLOR.black.default};
      font-size: 14px;
      line-height: 20px;
      word-wrap: break-word;
      border-radius: 8px;
      background: ${COLOR.charcoal};
      text-transform: none;
      border: 1px solid ${COLOR.white};

      .original {
        font-weight: 700;
      }

      .normalized {
        font-weight: 400;
      }
    }
  }

  .note {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    padding: 8px;
    background: ${COLOR.functionalRed[8]};
    border-radius: ${BORDER_RADIUS};
    color: ${COLOR.functionalRed.default};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    word-wrap: break-word;
    width: 100%;

    .note-icon {
      width: 16px;
      height: 16px;
      color: ${COLOR.functionalRed.default};
    }
  }
`;

export const StyledRecordingActions = styled('div')`
  display: flex;
  flex-direction: row;
  padding-top: 16px;
  padding-bottom: 0px;
  position: fixed;
  bottom: 0;
  left: 0px;
  right: 0px;

  .highlight-button {
    background-color: ${COLOR.primary} !important;
  }

  .action-button {
    width: 100%;
    text-transform: none;
    height: 72px;
    display: flex;
    justify-content: center;
    gap: 8px;
    padding: 12px, 16px, 24px, 16px;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    letter-spacing: -0.4px;
    color: ${COLOR.blue};
    border-radius: 0px;
    background-color: ${COLOR.white};
  }

  .pending-button {
    border: 1px solid transparent;
    color: ${COLOR.indigo[100]};
  }

  .rehear-button {
    background-color: ${COLOR.white};
  }

  .rehear-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-family: 'SF Pro Text';
    font-weight: 510;
    line-height: 16px;
    word-wrap: break-word;
    color: ${COLOR.darkBlue};

    .rehear-icon {
      width: 26px;
      height: 26px;
    }

    &.disabled {
      color: ${COLOR.darkV2[64]};
    }
  }

  .record-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-family: 'SF Pro Text';
    font-weight: 510;
    line-height: 16px;
    word-wrap: break-word;
    color: ${COLOR.darkBlue};

    .record-icon {
      width: 26px;
      height: 26px;
    }

    &.disabled {
      color: ${COLOR.darkV2[64]};
    }

    .progress {
      color: ${COLOR.labelBlue};
    }
  }

  .next-sentence-button {
    background: ${COLOR.white};
  }

  .next-sentence-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-family: 'SF Pro Text';
    font-weight: 510;
    line-height: 16px;
    word-wrap: break-word;
    color: ${COLOR.darkBlue};

    .next-sentence-icon {
      width: 24px;
      height: 24px;
    }

    &.disabled {
      color: ${COLOR.darkV2[64]};
    }
  }
`;
